import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const PostClosedAtTypography = styled(Typography)({
    fontSize: "12px",
    color: "var(--community-color-secondary-text)",
});

export const PostClosedAtDateSpan = styled(Box)({
    fontWeight: 700,
});
